import lodash from 'lodash'
import { Context, Id, ObservableValue } from '../../../common'
import { Role, User } from '../../users'
import { RequestedPermission, getPermissionNames } from './serverPermissionService'

export interface AuthError {
  message: string
}

export interface UserPermissions {
  readonly rolePermissions: string[]
  readonly superUser: boolean
}

export function userPermissionsEquals(a: UserPermissions, b: UserPermissions): boolean {
  return lodash.isEqual(a.rolePermissions, b.rolePermissions) && a.superUser === b.superUser
}

export function hasUserPermission(perms: UserPermissions, requestedPermission: RequestedPermission): boolean {
  if (perms.superUser) return true
  for (const permission of getPermissionNames(requestedPermission)) {
    if (!perms.rolePermissions.includes(permission)) return false
  }
  return true
}

export enum LoginType {
  CONTROL_QUESTION = 'control_question',
  AUTH_CODE = 'auth_code',
}

export const LOGIN_TYPE_INFO: Record<LoginType, string> = {
  [LoginType.CONTROL_QUESTION]: 'Через контрольный вопрос',
  [LoginType.AUTH_CODE]: 'Через код регистрации',
}

export interface AuthRequest {
  email: string | undefined
  message: string
}

export interface AppAuthService {
  readonly isInitialized: ObservableValue<boolean, Context>
  readonly authorizedUser: ObservableValue<User | undefined, Context>
  readonly role: ObservableValue<Role | undefined, Context>
  readonly permissions: ObservableValue<UserPermissions, Context>
  readonly authorizationRequest: ObservableValue<AuthRequest | undefined, Context>

  initialize(ctx: Context): Promise<void>
  login(ctx: Context, email: string, password: string): Promise<AuthError | undefined>
  logout(ctx: Context): Promise<void>
  loginBy(ctx: Context, type: LoginType, email: string, answer: string): Promise<AuthError | undefined>
  getControlQuestion(ctx: Context, email: string): Promise<string | undefined>
}

export interface LocalAppAuthService extends AppAuthService {
  authWithUserId(ctx: Context, userId: Id): Promise<void>
}
